import { ChangeEventHandler, FunctionComponent, MouseEventHandler } from 'react';
import { FelaCSS } from '@bridebook/ui';
import RadioToggleWrap from '../../../../components/bbcommon/inputs/radio-toggle-wrap/radio-toggle-wrap';
import Box from '../../../../components/fela/Box';
import { IStylingProps } from '../../../../themes/types';
import componentStyles from './radio-toggle.style';

export interface SharedTypes {
  block?: boolean;
  color?: string;
  iconColor?: string;
  checked?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
  noIconColor?: boolean;
  noBorder?: boolean;
  withBackground?: boolean;
}

interface PropTypes extends SharedTypes, IStylingProps {
  id: string;
  value?: string;
  name: string;
  label: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onClick?: MouseEventHandler<HTMLInputElement>;
  icon?: Function;
  iconWidth?: number;
  autoFocus?: boolean;
  wrapperStyle?: FelaCSS;
}

/**
 * @deprecated
 * Use FilterButton from bridebook/aura instead.
 */
const RadioToggle: FunctionComponent<PropTypes> = ({
  label,
  block,
  color,
  checked,
  defaultChecked,
  disabled,
  icon,
  iconColor,
  iconWidth,
  id,
  value,
  name,
  onChange,
  onClick,
  autoFocus,
  noIconColor,
  wrapperStyle,
  noBorder,
  withBackground,
  ...restProps
}) => {
  const Icon = icon;

  const activated = checked || defaultChecked;

  const styles = componentStyles({
    block,
    color,
    iconColor,
    noIconColor,
    disabled,
    checked: activated,
    noBorder,
    withBackground,
  });

  return (
    <RadioToggleWrap
      block={block}
      checked={checked}
      defaultChecked={defaultChecked}
      disabled={disabled}
      id={id}
      value={value}
      name={name}
      onChange={onChange}
      onClick={onClick}
      autoFocus={autoFocus}
      {...restProps}>
      <Box style={wrapperStyle ? { ...styles.wrapper, ...wrapperStyle } : styles.wrapper}>
        {Icon && (
          <Box style={styles.iconWrap}>
            <Icon width={iconWidth} checked={checked} />
          </Box>
        )}
        <Box style={styles.label}>{label}</Box>
      </Box>
    </RadioToggleWrap>
  );
};

/**
 * @deprecated
 * Use FilterButton from bridebook/aura instead.
 */
export default RadioToggle;
